/**
 * Custom hook for testimonials data
 */

import { useApi } from './useApi';
import { fetchTestimonialsData } from '@/lib/api/testimonials';

export function useTestimonialsData() {
  return useApi(fetchTestimonialsData, []);
}
